<template>
    <div style="background-color: #F4F7FC;">
        <div class="f_all">
            <div class="foot_partleft"></div>
            <div class="foot_part">
                <div class="foot_part_1">
                    <div class="foot_part_1_1">
                        <b-img :src="require('@/assets/logoacon.png')" alt="Image 1" class="nav-image"></b-img>
                    </div>
                    <div class="foot_part_1_2">
                        <div class="foot_part_1_2_1">National after-sales service hotline 400-666-1231</div>
                        <div class="foot_part_1_2_2">ACON Laboratories, Inc.</div>
                        <div class="foot_part_1_2_3">Address: 5850 Oberlin Drive,  #340, San Diego, CA92121, USA</div>
                        <div class="foot_part_1_2_4">ACON Biotech (HangZhou) Co., Ltd.</div>
                        <div class="foot_part_1_2_5">Address: No. 210 Zhenzhong Road, Aicheng Industrial Park,West Lake District, Hangzhou, 310030, Zhejiang, P.R. China</div>
                    </div>
                </div>
                <div class="foot_part_2" style="margin-top: -20px">
                    <div class="foot_part_2_1">
                        <div class="foot_part_2_1_1" style="margin-right: 64px;">
                            <a href="https://oc.aconcloud.net/privacy/?id=AconDDMPrivacyPolicy" style="color:#555555 ; text-decoration: none;">Privacy Policy</a>
                        </div>
                        <div class="foot_part_2_1_2">
                            <a href="https://oc.aconcloud.net/privacy/?id=AconDDMTermsOfUse" style="color:#555555 ; text-decoration: none;">Terms of Use</a>
                        </div>
                    </div>
                    <div class="foot_part_2_2">
                        <div class="foot_part_2_2_1" style="margin-right: 24px;">
                            <a href="https://www.instagram.com/acondiabetes1?igsh=MXdxdGxmOHB5dmE4Ng%3D%3D&utm_source=qr" target="_blank">
                                <b-img :src="require('@/assets/insicon.png')" class="icon-image"></b-img>
                            </a>
                        </div>
                        <div class="foot_part_2_2_2" style="margin-right: 24px;">
                            <a href="https://www.facebook.com/people/On-Call-ACON-Diabetes-Care/100076060089344/?mibextid=LQQJ4d" target="_blank">
                                <b-img :src="require('@/assets/facebookicon.png')" class="icon-image"></b-img>
                            </a>
                        </div>
                        <div class="foot_part_2_2_3">
                            <a href="https://www.youtube.com/@aconmarketing7621" target="_blank">
                                <img :src="require('@/assets/youtubeicon.png')" class="icon-image">
                            </a>
                        </div>
                    </div>
                    <div class="foot_part_2_3">© 2019 ACON</div>
                </div>
            </div>
            <div class="foot_partright"></div>
        </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'FooterPart'
  };
  </script>
  
  <style scoped>
.f_all{
    display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
}
.foot_part {
    flex: 0 0 1200px; /* 固定中间部分在1920px宽度下为1200px */
    display: flex;
    justify-content: space-between;
    align-items: center; /* 水平居中 */
    background-color: #F4F7FC;

}
.foot_part_1{
    margin-top: 56px;
}
.foot_partleft, .foot_partright {
    flex: 1; 
}
.foot_part_2_1, .foot_part_2_2{
    display: flex;
    margin-bottom: 24px;
}
.foot_part_1_1{
    margin-bottom: 16px;
}
.foot_part_1_2{
    margin-bottom: 40px;     
    font-family: Arial;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    color: #555555;
}
.foot_part_2{
    font-family: Arial;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    color: #555555;
}
  </style>